export default __webpack_public_path__ + "static/media/avatar.0fb5e1d3.png";